import { Box, Flex, Text } from '@chakra-ui/react'
import { theme } from 'Core'
import { MdKeyboardArrowRight } from 'react-icons/md'
import { IInformationCardProps } from '../interface'

export const InformationCardMobile = (props: IInformationCardProps) => {
  return (
    <>
      <Flex direction='column' paddingY='4'>
        <Text
          noOfLines={2}
          overflow='hidden'
          h='14'
          fontSize='lg'
          marginY='1'
          fontWeight='bold'
          textAlign='center'
        >
          {props.insurerName}
        </Text>
        <Box
          border='1px'
          borderColor='appGrey.200'
          marginY='auto'
          marginX='auto'
          backgroundColor='white'
        >
          <img src={props.image} className='w-[14vh] m-2 h-[10vh]' />
        </Box>
        {/* <Flex justifyContent='center' alignItems='center'>
          <Text color='primary.500' fontSize='16px' py='2'>
            Learn More..
          </Text>
          <Box marginY='auto'>
            <MdKeyboardArrowRight size={'22px'} color={`${theme.colors.primary}`} />
          </Box>
        </Flex> */}
      </Flex>
    </>
  )
}
